export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";